import { Action } from '@ngrx/store';
import { WmrpState, WmrpReplacementSched } from './wmrp.state';
// import { SafeResourceUrl } from '@angular/platform-browser';
// import { Params } from '@angular/router';

export const WMRPActionType = {

    GetMaterialsDictionary: '[WMRP] GetMaterialsDictionary',
    SetMaterialsDictionary: '[WMRP] SetMaterialsDictionary',
    GetWMRPModule: '[WMRP] GetWMRPModule',
    SetWMRPModule: '[WMRP] SetWMRPModule',
    SetDefaultConditions: '[WMRP] SetDefaultConditions',
    GetTemplateNames: '[WMRP] GetTemplateNames',
    SetTemplateNames: '[WMRP] SetTemplateNames',
    GetTemplateParameters: '[WMRP] GetTemplateParameters',
    SetTemplateParameters: '[WMRP] SetTemplateParameters',
    SaveTemplateParameters: '[WMRP] SaveTemplateParameters',
    SaveTemplateParametersSuccess: '[WMRP] SaveTemplateParametersSuccess',
    SaveAnalysisDetails: '[WMRP] SaveAnalysisDetails',
    SaveAnalysisDetailsSuccess: '[WMRP] SaveAnalysisDetailsSuccess',
    GetAnalysisDetails: '[WMRP] GetAnalysisDetails',
    SetRecentAnalysisDetails: '[WMRP] SetRecentAnalysisDetails',
    AddRecentAnalysisDetails: '[WMRP] AddRecentAnalysisDetails',
    RunAnalysisCustom: '[WMRP] RunAnalysisCustom',
    RunAnalysisTemplate: '[WMRP] RunAnalysisTemplate',
    ShowExpandParametersBtn: '[WMRP] ShowExpandParametersBtn',
    SelectRun: '[WMRP] SelectRun',
    StopAnalysisResultsPolling: '[WMRP] StopAnalysisResultsPolling',
    GenerateReplacementSchedule: '[WMRP] GenerateReplacementSchedule',
    GetReplacementSchedules: '[WMRP] GetReplacementSchedules',
    SetReplacementSchedules: '[WMRP] SetReplacementSchedules',
    SetSelectedReplacementSchedule: '[WMRP] SetSelectedReplacementSchedule',
    GetWmrtResults: '[WMRP] GetWmrtResults',
    SetWmrtResults: '[WMRP] SetWmrtResults',
    SetWmrtBoundary: '[WMRP] SetWmrtBoundary',
    StopSchedulePolling: '[WMRP] StopSchedulePolling',
    SetWMRPLayerFeatureVisible: '[WMRP] SetWMRPLayerFeatureVisible',
    SetWMRPLayers: '[WMRP] SetWMRPLayers',
    SetWMRPActiveLayer: '[WMRP] SetWMRPActiveLayer',
    SetWMRPAvailableLayer: '[WMRP] SetWMRPAvailableLayer',
    UpdateWMRPLayerFilter: '[WMRP] UpdateWMRPLayerFilter',
    GetExclusionLayerMains: '[WMRP] GetExclusionLayerMains',
    GetExclusionLayerMainsSuccess: '[WMRP] GetExclusionLayerMainsSuccess',
    GetExclusionLayerMainsError: '[WMRP] GetExclusionLayerMainsError',
    ToggleWMRPLayer: '[WMRP] ToggleWMRPLayer',
    UpdateScheduleYear: '[WMRP] UpdateScheduleYear',
    SaveAnalysisTitle: '[WMRP] SaveAnalysisTitle',
    DeleteAnalysisRun: '[WMRP] DeleteAnalysisRun',
    SaveScheduleTitle: '[WMRP] SaveScheduleTitle',
    DeleteSchedule: '[WMRP] DeleteSchedule',
    // AddExclusionLayerMain: '[WMRP] AddExclusionLayerMain',
    // RemoveExclusionLayerMain: '[WMRP] RemoveExclusionLayerMain',
};


export class GetMaterialsDictionary implements Action {
    public type: string = WMRPActionType.GetMaterialsDictionary;

    constructor(public payload: any = null) { }
}

export class SetMaterialsDictionary implements Action {
    public type: string = WMRPActionType.SetMaterialsDictionary;

    constructor(public payload: any = null) { }
}

export class GetWMRPModule implements Action {
    public type: string = WMRPActionType.GetWMRPModule;

    constructor(public payload: any = null) { }
}

export class SetWMRPModule implements Action {
    public type: string = WMRPActionType.SetWMRPModule;

    constructor(public payload: any = null) { }
}

export class SetDefaultConditions implements Action {
    public type: string = WMRPActionType.SetDefaultConditions;

    constructor(public payload: any = null) { }
}

export class GetTemplateNames implements Action {
    public type: string = WMRPActionType.GetTemplateNames;

    constructor(public payload: any = null) { }
}

export class SetTemplateNames implements Action {
    public type: string = WMRPActionType.SetTemplateNames;

    constructor(public payload: any = null) { }
}

export class GetTemplateParameters implements Action {
    public type: string = WMRPActionType.GetTemplateParameters;

    constructor(public payload: any = null) { }
}

export class SetTemplateParameters implements Action {
    public type: string = WMRPActionType.SetTemplateParameters;

    constructor(public payload: any = null) { }
}

export class SaveTemplateParameters implements Action {
    public type: string = WMRPActionType.SaveTemplateParameters;

    constructor(public payload: any = null) { }
}

export class SaveTemplateParametersSuccess implements Action {
    public type: string = WMRPActionType.SaveTemplateParametersSuccess;

    constructor(public payload: any = null) { }
}

export class SaveAnalysisDetails implements Action {
    public type: string = WMRPActionType.SaveAnalysisDetails;

    constructor(public payload: any = null) { }
}

export class SaveAnalysisDetailsSuccess implements Action {
    public type: string = WMRPActionType.SaveAnalysisDetailsSuccess;

    constructor(public payload: any = null) { }
}

export class GetAnalysisDetails implements Action {
    public type: string = WMRPActionType.GetAnalysisDetails;

    constructor(public payload: any = null) { }
}

export class SetRecentAnalysisDetails implements Action {
    public type: string = WMRPActionType.SetRecentAnalysisDetails;

    constructor(public payload: any = null) { }
}

export class AddRecentAnalysisDetails implements Action {
    public type: string = WMRPActionType.AddRecentAnalysisDetails;

    constructor(public payload: any = null) { }
}

export class RunAnalysisCustom implements Action {
    public type: string = WMRPActionType.RunAnalysisCustom;

    constructor(public payload: any = null) { }
}

export class RunAnalysisTemplate implements Action {
    public type: string = WMRPActionType.RunAnalysisTemplate;

    constructor(public payload: any = null) { }
}

export class GenerateReplacementSchedule implements Action {
    public type: string = WMRPActionType.GenerateReplacementSchedule;

    constructor(public payload: any = null) { }
}

export class ShowExpandParametersBtn implements Action {
    public type: string = WMRPActionType.ShowExpandParametersBtn;

    constructor(public payload: any = null) { }
}

export class SelectRun implements Action {
    public type: string = WMRPActionType.SelectRun;

    constructor(public payload: any = null) { }
}

export class StopAnalysisResultsPolling implements Action {
    public type: string = WMRPActionType.StopAnalysisResultsPolling;

    constructor(public payload: any = null) { }
}

export class GetReplacementSchedules implements Action {
    public type: string = WMRPActionType.GetReplacementSchedules;

    constructor(public payload: any = null) { }
}

export class SetReplacementSchedules implements Action {
    public type: string = WMRPActionType.SetReplacementSchedules;

    constructor(public payload: WmrpReplacementSched[] = null) { }
}

export class SetSelectedReplacementSchedule implements Action {
    public type: string = WMRPActionType.SetSelectedReplacementSchedule;

    constructor(public payload: WmrpReplacementSched = null) { }
}

export class GetWmrtResults implements Action {
    public type: string = WMRPActionType.GetWmrtResults;

    constructor(public payload: any = null) { }
}

export class SetWmrtResults implements Action {
    public type: string = WMRPActionType.SetWmrtResults;

    constructor(public payload: any = null) { }
}

export class SetWmrtBoundary implements Action {
    public type: string = WMRPActionType.SetWmrtBoundary;

    constructor(public payload: WmrpState = null) { }
}

export class StopSchedulePolling implements Action {
    public type: string = WMRPActionType.StopSchedulePolling;

    constructor(public payload: any = null) { }
}

export class SetWMRPLayerFeatureVisible implements Action {
    public type: string = WMRPActionType.SetWMRPLayerFeatureVisible;

    constructor(public payload: any = null) { }
}

export class SetWMRPLayers implements Action {
    public type: string = WMRPActionType.SetWMRPLayers;

    constructor(public payload: any = null) { }
}

export class SetWMRPActiveLayer implements Action {
    public type: string = WMRPActionType.SetWMRPActiveLayer;

    constructor(public payload: any = null) { }
}

export class SetWMRPAvailableLayer implements Action {
    public type: string = WMRPActionType.SetWMRPAvailableLayer;

    constructor(public payload: any = null) { }
}

export class UpdateWMRPLayerFilter implements Action {
    public type: string = WMRPActionType.UpdateWMRPLayerFilter;

    constructor(public payload: any = null) { }
}

export class GetExclusionLayerMains implements Action {
    public type: string = WMRPActionType.GetExclusionLayerMains;

    constructor(public payload: any = null) { }
}

export class GetExclusionLayerMainsSuccess implements Action {
    public type: string = WMRPActionType.GetExclusionLayerMainsSuccess;

    constructor(public payload: any = null) { }
}

export class GetExclusionLayerMainsError implements Action {
    public type: string = WMRPActionType.GetExclusionLayerMainsError;

    constructor(public payload: any = null) { }
}

export class ToggleWMRPLayer implements Action {
    public type: string = WMRPActionType.ToggleWMRPLayer;

    constructor(public payload: any = null) { }
}

export class UpdateScheduleYear implements Action {
    public type: string = WMRPActionType.UpdateScheduleYear;

    constructor(public payload: any = null) { }
}

export class SaveAnalysisTitle implements Action {
    public type: string = WMRPActionType.SaveAnalysisTitle;

    constructor(public payload: any = null) { }
}

export class DeleteAnalysisRun implements Action {
    public type: string = WMRPActionType.DeleteAnalysisRun;

    constructor(public payload: any = null) { }
}

export class SaveScheduleTitle implements Action {
    public type: string = WMRPActionType.SaveScheduleTitle;

    constructor(public payload: any = null) { }
}

export class DeleteSchedule implements Action {
    public type: string = WMRPActionType.DeleteSchedule;

    constructor(public payload: any = null) { }
}

// export class AddExclusionLayerMain implements Action {
//     public type: string = WMRPActionType.AddExclusionLayerMain;

//     constructor(public payload: any = null) { }
// }

// export class RemoveExclusionLayerMain implements Action {
//     public type: string = WMRPActionType.RemoveExclusionLayerMain;

//     constructor(public payload: any = null) { }
// }

export type WMRPAction =
    GetMaterialsDictionary |
    SetMaterialsDictionary |
    GetWMRPModule |
    SetWMRPModule |
    SetDefaultConditions |
    GetTemplateNames |
    SetTemplateNames |
    GetTemplateParameters |
    SetTemplateParameters |
    SaveTemplateParameters |
    SaveTemplateParametersSuccess |
    SaveAnalysisDetails |
    RunAnalysisCustom |
    ShowExpandParametersBtn |
    GetAnalysisDetails |
    RunAnalysisTemplate |
    AddRecentAnalysisDetails |
    SelectRun |
    StopAnalysisResultsPolling |
    GenerateReplacementSchedule |
    GetReplacementSchedules |
    SetReplacementSchedules |
    SetSelectedReplacementSchedule |
    GetWmrtResults |
    SetWmrtResults |
    SetWmrtBoundary |
    StopSchedulePolling |
    SetWMRPLayerFeatureVisible |
    SetWMRPLayers |
    SetWMRPActiveLayer |
    SetWMRPAvailableLayer |
    UpdateWMRPLayerFilter |
    GetExclusionLayerMains |
    GetExclusionLayerMainsSuccess |
    GetExclusionLayerMainsError |
    ToggleWMRPLayer |
    UpdateScheduleYear |
    SaveAnalysisTitle |
    DeleteAnalysisRun |
    SaveScheduleTitle |
    DeleteSchedule
    // AddExclusionLayerMain |
    // RemoveExclusionLayerMain
    ;
